export const optimumPlanDropdown = "/plans-addons-finance";
export const saveOrderAPI = "/orders";
export const verifTokenAPI = (tokenparam, orderparam) =>
  `/orders/${orderparam}/verify-token?token=${tokenparam}`;
export const verifyPCITokenAPI = (orderId) =>
  `/orders/${orderId}/update-payment-info`;
export const fetchLocationAPI = (zipcode) =>
  `/zipcode-locations?zipcode=${zipcode}`;
export const calculateOrderPrice = "/orders/calculate-order-price";
export const filterMobiileAPI = ({ plan_id, search_text }) =>
  `/mobile-devices?plan_id=${plan_id}&search_text=${search_text || ""}`;
export const send_otp = (orderId) => `/orders/${orderId}/send-otp`;
export const validate_otp = (orderId) => `/orders/${orderId}/validate-otp`;
export const capture_PCI = (orderId) =>
  `/pci-capture-endpoint?order_id=${orderId}`;
export const healthCheckEndpoint = "health-check";
